<script setup>
import { customAlert } from '@general/js/utils/swalMessages'
import { reactive, ref } from 'vue'

const props = defineProps({
    userInfo: {
        type: Object,
        default: '',
    },
    vehicles: {
        type: Array,
        default: [],
    },
    urlStore: {
        type: String,
        default: '',
    },
    urlTerms: {
        type: String,
        default: '',
    },
})

const model = reactive({
    fullname: props.userInfo.fullname,
    dni: props.userInfo.dni,
    giveaway_vehicle_id: props.userInfo.giveaway_vehicle_id || '',
    terms: false,
})
const readonly = ref(props.userInfo.giveaway_vehicle_id ? true : false)

const submit = async event => {
    try {
        const formData = new FormData(event.target)
        const { data } = await axios.post(props.urlStore, formData)

        customAlert(data)

        if (data.type === 1) {
            readonly.value = true
        }
    } catch (error) {
        const { errors } = error.response.data

        if (errors) {
            const errorsValues = Object.values(errors).flat()

            customAlert({
                type: 3,
                title: '¡Error!',
                subtitle: errorsValues[0],
            })
        }
    }
}

const reset = async () => {
    try {
        const { data } = await axios.post(props.urlReset)

        model.dni = ''
        model.giveaway_vehicle_id = ''
        model.terms = false

        readonly.value = false
    } catch (error) {
        console.error(error)
    }
}
</script>

<template>
    <form
        @submit.prevent="submit($event)"
        class="giveaway__form"
    >
        <div class="input-box">
            <label>Nombre</label>
            <input
                v-model="model.fullname"
                type="text"
                name="fullname"
                readonly
            />
        </div>
        <div class="input-box">
            <label>DNI*</label>
            <input
                v-model="model.dni"
                type="tel"
                name="dni"
                :readonly="readonly"
            />
        </div>
        <div class="input-box">
            <label>Vehículo*</label>
            <select
                v-model="model.giveaway_vehicle_id"
                name="giveaway_vehicle_id"
                :disabled="readonly"
            >
                <option value="">Seleccionar</option>
                <option
                    v-for="vehicle in vehicles"
                    :value="vehicle.id"
                    :key="vehicle.id"
                >
                    {{ vehicle.name }}
                </option>
            </select>
        </div>
        <div
            class="input-box"
            v-if="!readonly"
        >
            <label
                for="terms"
                class="checkbox"
            >
                <input
                    v-model="model.terms"
                    type="checkbox"
                    name="terms"
                    id="terms"
                    :disabled="readonly"
                />
                Acepto los
                <a
                    :href="props.urlTerms"
                    target="_blank"
                    >Términos y Condiciones</a
                >
            </label>
        </div>
        <div
            v-if="!readonly"
            class="input-box"
        >
            <button
                type="submit"
                class="btn btn--green"
                :disabled="!model.terms"
            >
                Participar
            </button>
        </div>
        <template v-else>
            <div class="giveaway__message">¡Ya estas participando del Sorteo 🎉!</div>
        </template>
    </form>
</template>

<style lang="scss" scoped>
.giveaway__form {
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    display: grid;
    gap: 1rem 2rem;
    grid-template-columns: repeat(1, 1fr);
    padding: 1.5rem;
    position: relative;
    z-index: 1;

    @media screen and (min-width: 1181px) {
        padding: 3rem;
    }
}

.giveaway__message {
    background-color: rgba($color: #17894a, $alpha: 0.2);
    border: 1px solid #17894a;
    border-radius: 10rem;
    color: #17894a;
    font-size: 1.125rem;
    font-weight: 500;
    margin-top: 1rem;
    padding: 0.5rem;
    text-align: center;
}

.input-box {
    select {
        &:disabled {
            background-color: #f7f7f7;
            color: #000;
        }
    }

    button {
        margin-top: 1rem;
        width: 100%;
    }

    .checkbox {
        cursor: pointer;
        display: block;
        font-size: 0.875rem;
        padding: 0.5rem 0 0.5rem 1.125rem;
        position: relative;

        input {
            left: 0;
            position: absolute;
            top: 13px;
        }

        a {
            color: #146e9d;
        }
    }
}
</style>
